const automations = {
  table: {
    header: {
      suppliers: 'Flotas',
    },
    filters: {
      suppliers: {
        title: 'Flotas',
      },
    },
  },
  wizard: {
    information: {
      supplier: 'Flotas',
    },
  },
};

export default automations;
